import { Component, ElementRef, HostListener, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from '@angular/material/dialog';

import { Observable, fromEvent } from 'rxjs';

import { AuthService } from 'src/app/services/auth/auth.service';
import { ToolsService } from 'src/app/services/tools/tools.service';

import { ClientOrdersService } from 'src/app/services/apiclient/order/clientorders.service';


import { FulleStockService } from "src/app/services/api/fulle/fulle-stock/fulle-stock.service";
import { DialogsService } from 'src/app/services/manage/dialogs/dialogs.service';
import { CurrencyService } from 'src/app/services/manage/currency/currency.service';
import { environment } from 'src/environments/environment';
import { MyPosService } from 'src/app/services/apiclient/myPos/myPos.service';
import { DeviceCheck } from 'src/app/services/api/DeviceCheck/DeviceCheck.service';
import { TranslateService } from '@ngx-translate/core';



declare var MyPOSEmbedded: any;
@Component({
  selector: 'app-my-pos',
  templateUrl: './my-pos.component.html',
  styleUrls: ['./my-pos.component.css']
})
export class MyPosComponent implements OnInit {
  eventHeight: Observable<any> = fromEvent(window, "resize");
  innerHeight: number = window.innerHeight;
  innerWidth: number = window.innerWidth;


  proccessing: any = false;
  spinnerIsLoading: boolean = false;
  spinnerPayIsLoading: boolean = false;
  currency: any;
  merchantClient: any;
  // Point of sale
  currPOS: any = this.tools.getStor("point_of_sale");

  //amount
  amount: any;
  loader: boolean = false;
  statusMessage = this.translate.instant('credit_due.loader_trai');

  authUserObser: any;
  currencyObser: any;
  user$: any;
  id_user: any;

  dataOrder: any;
  dataCredit: any;
  dataRefill: any;
  paymentPos: any;
  mypos_account: any;

  paymentInProcess = false;
  errorButton = false;
  // VISA TEST
  // 4006090000000007  ok

  // Name: TEST
  // CVC: 111
  // Expiry: 12/2030


  customization = {
    formBackgroundColor: '#555d60',
    labelFontSize: '12px',
    labelColor: '#fff',
    inputBorderRadius: '0px',
    payButtonBorderColor: '#f8be37',
    payButtonBackgroundColor: '#f8be37',
    payButtonColor: '#fff',
    payButtonFontSize: '14px',
  }

  paymentParams: any;
  FormButtonPayPmypos = true;


  metadata_provenance: any;//1 oder 2 credit 3 refill
  lettering_intent_id: any;//2
  refill_intent_id: any;//3



  interval: any = null;
  time = 0;
  startSpinner = true;
  heightColumn: any;
  paymentSucceded: any;
  applegoogleButonVisible = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<MyPosComponent>,

    private tools: ToolsService,
    private auth: AuthService,
    private dialog: MatDialog,
    private orderApi: ClientOrdersService,
    private stockApi: FulleStockService,
    public myDials: DialogsService,
    private elementRef: ElementRef,
    private currencyMng: CurrencyService,
    private MyPosService: MyPosService,
    private DeviceCheck: DeviceCheck,
    public translate: TranslateService,


  ) {

    //on doit recuperer les wallet et sid pour la creation du widget



    this.amount = data.amount;
    this.id_user = data.id_user ? data.id_user : null;

    this.merchantClient = data.merchantClient ? data.merchantClient : null;
    this.metadata_provenance = data.metadata;

    this.mypos_account = data.mypos_account ? data.mypos_account : null;



    //order metadata 1  order_id
    this.dataOrder = data.dataOrder ? data.dataOrder : null;


    //credit metadata 2  lettering_intent_id
    this.dataCredit = data.dataCredit ? data.dataCredit : null;
    this.lettering_intent_id = data.lettering_intent_id ? data.lettering_intent_id : null;

    //refill metadata 3  lettering_intent_id
    this.dataRefill = data.dataRefill ? data.dataRefill : null;
    this.refill_intent_id = data.refill_intent_id ? data.refill_intent_id : null;


    this.authUserObser = this.auth.getUser.subscribe(user => {
      this.user$ = user;

    });






    //currency
    // this.currencyObser = this.currencyMng.getCurrCurrency().subscribe(data => {
    //   this.currency = data.code;
    // });


  }
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.getHeigthContent();
  }

  getHeigthContent() {
    setTimeout(() => {
      // let body: any = document.getElementById('body')?.clientHeight
      let bodyHeader: any = document.getElementById('body-header')?.clientHeight
      let bodyFooter: any = document.getElementById('body-footer')?.clientHeight
      //content taille maximal du pop -header et footer
      this.heightColumn = this.innerHeight - bodyHeader - bodyFooter - 40;
    }, 500);
  }


  ngOnInit(): void {
    this.paymentSucceded = false;
    this.spinnerIsLoading = true;
    // recupere wallet et sid
    //  this.getClientKeyMypos();
    //paiement  commande order
    if (this.metadata_provenance == 1) {
      this.submitOrder();
    }
    else {
      //paiement  refill et  credi
      // metadata_provenance 2 et 3
      let datatosend: any = {
        my_order_id: this.metadata_provenance == 2 ? this.lettering_intent_id : this.refill_intent_id
      };
      this.initMyPosPayment(datatosend);
    }
  }

  demo() {
    if (this.mypos_account) {
      this.mypos_account.sandbox = true;
      this.mypos_account.sid = '000000000000010';
      this.mypos_account.wallet = '61938166610';
      this.mypos_account.index = 1;
    }
  }

  /**
   * @description recupere la clé client pour creer l'element   my pos
   */
  getClientKeyMypos() {
    // this.spinnerIsLoading = false;
    this.MyPosService.getClientKeyMyposBypof(this.id_user, this.metadata_provenance).subscribe((data: any) => {
      if (data.err || data.code && data.code !== 0) {
        this.spinnerPayIsLoading = false;
        data.err ? this.handleError(data.err, 5000) : this.handleError(null, 5000);
        return;
      }
      //creation du commande
      this.submitOrder();
    })
  }

  //detruit les observables
  ngOnDestroy(): void {
    if (this.authUserObser)
      this.authUserObser.unsubscribe();
    if (this.currencyObser)
      this.currencyObser.unsubscribe();
  }






  /**
  * @description init MyPosPayment card
  */
  initMyPosPayment(mydata?: any) {

    //mode demo
    if (environment.production == false) {

      this.demo();

    }



    this.setparam(mydata);

    this.spinnerIsLoading = true;
    this.paymentPos = null;


    let that = this;



    let callbackParams: any = {
      isSandbox: this.mypos_account.sandbox,


      onSuccess: function (data: any) {

        that.paymentSucceded = true;
        //on paye
        //on ferme et on finalize la commande
        that.onSuccess(data);

      },
      onError: function (err: any) {
        console.error('err', err)
        that.paymentInProcess = false;
        that.paymentSucceded = false;

        if (err.message && err.message.event && err.message.event == "error") {
          that.errorButton = true;
        }
        // that.handleError(null, 4000);
        //on cache le button
        console.error('err', err)
      },
      onMessageReceived: function (messages: any) {
        //Error and info messages.
        that.paymentInProcess = false;
        that.paymentSucceded = false;
      }
    };
    if (this.FormButtonPayPmypos) {
      // createPreAuthorization
      // createPaymentForm
      MyPOSEmbedded.createPaymentForm(
        'embeddedCheckout',
        this.paymentParams,
        callbackParams,
        this.customization
      ).then((paymentFrame: any) => {
        //au demmarrage set the paypos
        this.paymentPos = paymentFrame;
        this.spinnerIsLoading = false;
        this.startSpinner = false;
        this.getHeigthContent();
      });
    }
    else {
      MyPOSEmbedded.createPayment(
        'embeddedCheckout',
        this.paymentParams,
        callbackParams, this.customization
      ).then((payment: any) => {
        this.paymentPos = payment;
        this.spinnerIsLoading = false;
        this.startSpinner = false;
        this.getHeigthContent();
      });
    }
  }

  /**
  * @description onSuccess freme la dialog
  */
  onSuccess(data: any) {
    this.closeDial({ "success": data })
  }

  /**
  * @description onSuccess freme la dialog
  */
  onSuccessAppleGoogle(data: any) {
    data.OrderID = this.mypos_account.my_order_id
    this.closeDial({ "success": data })
  }

  /**
  * @description set param for pay cb
  */
  setparam(data?: any) {
    let routeNotify = this.metadata_provenance == 1 ?
      'myposOrderpaymentSucceeded' : this.metadata_provenance == 2 ?
        'myposCreditpaymentSucceeded' :
        'myposRefillpaymentSucceeded'
    this.paymentParams = {
      sid: this.mypos_account.sid,
      ipcLanguage: this.tools.getStor("lang") ? this.tools.getStor("lang") : "fr", //Checkout page language (ISO 2 format).'en'
      walletNumber: this.mypos_account.wallet,
      amount: this.amount,
      currency: this.mypos_account.currency.shortname,
      orderID: this.mypos_account.my_order_id,//attention uniq en function des metadataprovenance
      urlNotify: this.mypos_account.urlNotify + routeNotify,
      urlOk: window.location.href, // Optional - required only for iDeal
      urlCancel: window.location.href, // Optional - required only for iDeal
      cartItems: [
        {
          article: 'online',
          quantity: 1,
          price: this.amount,
          currency: this.mypos_account.currency.shortname,
        }
      ],
      keyIndex: this.mypos_account.index,
      OutputFormat: "JSON"
    };
  }

  /**
   * @description procede intent payment
   */
  processPayment(ev: any) {
    this.paymentInProcess = true;
    // setTimeout(() => {
    //   this.paymentInProcess = false;
    // }, 2000);
    this.paymentPos.processPayment();
  }

  /**
  * @description Créer une commande et  submit pay
  */
  submitOrder(order_id_device?: any) {
    /**
     * Check stock befor
     */
    this.stockApi.displayAlertStockDialog(null).then((result) => {
      if (result.data) {
        this.orderApi.checkError(
          this.dataOrder.orderCard,
          this.dataOrder.billingAddress,
          this.dataOrder.delivryAddress,
          this.dataOrder.selectedRelay,
          this.dataOrder.isRelay,
          0,
          // this.amount
        ).then(async (data) => {
          /** * Si erreur  */
          if (data) {
            if (data === "invalidDateproduct") {
              //actualise la page
              setTimeout(() => {
                window.location.reload();
                this.closeDial();
              }, 1000);
              return;
            }
            setTimeout(() => {
              this.handleError();
              // this.myStripeApi.setloaderMethodStripe(false);
            });
            /**
             * Si aucune erreur alors on crée la commande
             */
          } else {
            this.orderApi.checkOrderAmount(
              this.dataOrder.billingAddress, // billingAddress
              this.dataOrder.delivryAddress, // delivryaddress
              (this.dataOrder.isRelay ? this.dataOrder.selectedRelay : null), // relay
              this.merchantClient // merchantClient
              // checkopenpof
              // uberFee
            ).then((val: any) => {
              if (val.code === 0 && val.amount == this.amount) {
                //creation commande
                this.orderApi.submitOrder(
                  true, // payment_type
                  this.dataOrder.orderCard, // currCard
                  this.dataOrder.billingAddress, // billingAddress
                  this.dataOrder.delivryAddress, // delivryaddress
                  (this.dataOrder.isRelay ? this.dataOrder.selectedRelay : null), // relay
                  null, // paypal_order_id
                  null, // payment_intent_id
                  this.merchantClient, // merchantClient
                  this.dataOrder.payment_intent_id, // paymentIntentId
                  order_id_device // order_id_device
                  // url
                  // payment_intent_id_saved
                  // uberFee
                ).then(
                  data => {
                    if (data.code === -9) {
                      this.mypos_account = data.mypos_account;
                      this.applegoogleButonVisible = data.mypos_account.apple_google ? data.mypos_account.apple_google : false;
                      // this.spinnerIsLoading = false;
                      // this.startSpinner=false;
                      this.initMyPosPayment(data);
                    }
                    else if (data.code === -100) {
                      let error = {
                        error: "errorYetPayed"
                      }
                      this.closeDial(error);
                    }
                    else {
                      /**  * Erreur  */
                      this.handleError(data.message);
                    }
                  }
                );
              }
              else // On affiche un message d'erreur
                this.handleError();
            }).catch((err: any) => {
              this.handleError();
            });
          }
        })
      }
    });
  }

  /**
   * @description Error
   */
  handleError(data?: any, time?: any) {
    let t = time ? time : 8000;
    let erroTxt = this.translate.instant('loginComp.error');
    let message = data ? erroTxt + data : erroTxt;
    this.tools.openSnackBar(message, "warn", t);
    this.closeDial();
    this.startSpinner = false;
  }

  closeDial(data?: any) {
    // data.OrderID=this.mypos_account.my_order_id;
    this.dialogRef.close(data);
  }

  /***************
  * Device Check
   ************/

  timerSetOrderIntent(data: any) {
    this.time = 5;
    this.interval = setInterval(() => {
      if (this.time > 0)
        this.time -= 1;
      if (this.time == 0 && this.interval) {
        clearInterval(this.interval);
        this.interval = null;
        this.loader = false;
        let message = this.translate.instant('error_device_no_auto_creation');
        this.handleError(message, 5000);
      }
      if (this.interval)
        this.getStatusOrderIntent(data);
    }, 1000);
  }

  getStatusOrderIntent(data: any) {
    this.DeviceCheck.getStatusOrderIntent(data).then(value => {
      // value.order_intent.status = 1
      if (value.order_intent.status == 1) {
        //on stop le timer
        this.time = 0;
        this.submitOrder(data.order_id_device);
      }
    }).catch(err => {
      this.loader = false;
      console.error('err', err)
    })
  }
}
